import { useState, useEffect } from 'react';
import * as M from '@/components/Institutional/AdvertiseHere/FormModal/styles';
import useOutsideClickRef from '@/hooks/useOutsideClickRef';
import Link from 'next/link';
import CompaniesList, { Company } from '..';
import { mglGray } from '@/styles/designSystemColors';
import Icon from '@/components/Layout/Icon';

interface CompanySearchProps {
  companies: Company[];
}

export default function CompanySearch({ companies }: CompanySearchProps) {
  const [isSelectMenuOpen, setIsSelectMenuOpen] = useState(false);
  const [companySelectValue, setCompanySelectValue] = useState('');
  const selectRef = useOutsideClickRef({ setIsOpen: setIsSelectMenuOpen });

  useEffect(() => {
    if (companySelectValue && companySelectValue.length > 1 && !isSelectMenuOpen) {
      setIsSelectMenuOpen(true);
    }

    if (!companySelectValue || companySelectValue.length === 1) {
      setIsSelectMenuOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companySelectValue]);

  const filteredOptions = companies.filter(option => option.titulo.toLowerCase().includes(companySelectValue.toLowerCase()));

  return (
    <>
      <div className="relative mx-0 my-10 [&>svg]:absolute [&>svg]:left-2 [&>svg]:top-2">
        <input
          className="min-h-10 w-full rounded border border-solid border-mglGray400 bg-mglGray50 py-2 pl-8 pr-4 text-sm placeholder:text-mglGray500"
          placeholder="Pesquisar"
          onChange={event => setCompanySelectValue(event.target.value)}
          value={companySelectValue}
        />
        <Icon icon="mdi:magnify" color={mglGray.mglGray500} />
        <M.FormModalSelect ref={selectRef}>
          <M.FormModalSelectOptions isOpen={isSelectMenuOpen}>
            {filteredOptions.map(option => (
              <Link href={option.url} passHref key={option.url}>
                <a
                  className="block cursor-pointer p-2 text-[0.625rem] text-base text-mglGray900 transition-all duration-300 ease-ease hover:bg-mglBlue400 hover:text-mglGray50 focus:bg-mglBlue400 focus:text-mglGray50"
                  title={`Ir para página de ${option.titulo}`}>
                  {option.titulo}
                </a>
              </Link>
            ))}
          </M.FormModalSelectOptions>
        </M.FormModalSelect>
      </div>
      <CompaniesList companies={companies} />
    </>
  );
}
